import { ActionTypes } from '../../constants/ActionTypes';
import { IDmsResponse } from '../../interfaces/Dms/Dms';
const INIT_STATE: IDmsResponse = {
  pageListSize: 0,
  docModel: [],
  archiveFolderList: [],
  dmsLoading: false,
  folderName: '',
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_DMS_LIST: {
      return {
        ...state,
        dmsLoading: true,
      };
    }
    case ActionTypes.GET_DMS_LIST_SUCCESS: {
      return {
        ...state,
        currentPageNumber: action.payload.currentPageNumber,
        pageListSize: action.payload.pageListSize,
        docModel: [...state.docModel, ...action.payload.docModel],
        folderName: action.payload.folderName,
        dmsLoading: false,
      };
    }
    case ActionTypes.GET_DMS_FULL_LIST: {
      return {
        ...state,
        dmsLoading: true,
      };
    }
    case ActionTypes.GET_DMS_LIST_FULL_SUCCESS: {
      return {
        ...state,
        archiveFolderList: action.payload.archiveFolderList,
        dmsLoading: false,
      };
    }
    default:
      return state;
  }
};
